// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Res, setRes, TFunc, UI, uqStringify } from "tonva-react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FieldItem, FieldItemInt, FieldItemNum, FieldItemString, FieldItemId } from "tonva-react";
import { CustomerBoundHistory } from "./JkCoupon";

/*--fields--*/
const fields = {
	id: {
		"name": "id",
		"type": "id",
		"isKey": false,
		"label": "Id"
	} as FieldItemId,
	customer: {
		"name": "customer",
		"type": "id",
		"isKey": false,
		"label": "Customer"
	} as FieldItemId,
	boundTo: {
		"name": "boundTo",
		"type": "id",
		"isKey": false,
		"label": "BoundTo"
	} as FieldItemId,
	boundType: {
		"name": "boundType",
		"isKey": false,
		"label": "BoundType"
	} as undefined,
	operation: {
		"name": "operation",
		"isKey": false,
		"label": "Operation"
	} as undefined,
};
/*==fields==*/

const fieldArr: FieldItem[] = [
	fields.customer, fields.boundTo, fields.boundType, fields.operation, 
];

export const ui: UI = {
	label: "CustomerBoundHistory",
	fieldArr,
	fields,
};

const resRaw: Res<any> = {
	$zh: {
	},
	$en: {
	}
};
const res: any = {};
setRes(res, resRaw);

export const t:TFunc = (str:string|JSX.Element): string|JSX.Element => {
	return res[str as string] ?? str;
}

export function render(item: CustomerBoundHistory):JSX.Element {
	return <>{uqStringify(item)}</>;
};
